import { backupRoutes } from "@/mocks/home";

export default function BackupAccess() {
  return (
    <section id="backup" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
              Backup Access
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
              新域名与备用访问方案
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              主入口失效并不意味着完全中断。提前准备几条备用路径，可以在域名变动或线路波动时保持基本访问。
              下面四种方案各有适用场景，建议至少保留其中两种。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {backupRoutes.map((route) => (
            <article
              key={route.title}
              className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex flex-col"
            >
              <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className={`${route.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg text-foreground-950">
                {route.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600 flex-1">
                {route.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs self-start">
                <i className="ri-filter-3-line" aria-hidden="true"></i>
                {route.suitable}
              </span>
            </article>
          ))}
        </div>

        <div className="mt-6 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div className="flex items-start gap-3">
            <span className="flex-none w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
              <i className="ri-information-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="text-xs md:text-sm leading-relaxed text-foreground-600">
              备用线路的可用状态会随时间变化，使用前请先与官方公告核对，避免把已经失效或来源不明的地址当作备用入口长期保留。
            </p>
          </div>
          <a
            href="#faq"
            className="flex-none inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-question-line" aria-hidden="true"></i>
            查看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}